/**
 * Created by Ivan on 19.04.2024
 */

const StickerView = cc.Node.extend({
    ctor: function (sticker, options) {
        this._super();

        this.options = options || {};
        this.sticker = sticker;
        this.bundle = bundles[StickersCollection.getCollectionBundle(sticker.collection.index, sticker.collection.season)];

        this.setAnchorPoint(0.5, 0.5);

        this.createImage();
        this.createLabel();
        this.createFrame();

        this.setCascadeOpacityEnabledRecursively(true);

        this.update();

        if (this.options.withUpdate) {
            sticker.on("update", this.createListener(this.update.bind(this)));
        }
    },

    createFrame: function (rare) {
        const styles = cleverapps.styles.StickerView.frame;
        let animation;
        switch (rare) {
            case false:
                animation = bundles.sticker.jsons.silver_frame_json;
                break;
            case true:
                animation = bundles.sticker.jsons.gold_frame_json;
                break;
            default:
                animation = bundles.sticker.jsons.gray_frame_json;
                break;
        }
        if (this.frame) {
            this.frame.removeFromParent();
            this.frame = undefined;
        }
        const frame = this.frame = new cleverapps.Spine(animation);
        frame.setAnimation(0, "animation");
        this.setContentSize(frame.getContentSize());
        frame.setAlignment(this.width / 2, this.height / 2);
        this.addChild(frame);
        frame.setLocalZOrder(styles.zOrder);
    },

    createImage: function () {
        const styles = cleverapps.styles.StickerView.image;
        const image = this.image = new cc.Sprite();
        image.setAlignment(styles);
        styles.zOrder && image.setLocalZOrder(styles.zOrder);

        this.addChild(image);
        image.setLocalZOrder(0);
    },

    update: function () {
        const styles = cleverapps.styles.StickerView;
        const opened = this.sticker.getState() === Sticker.STATE_OPENED;

        if (opened) {
            this.image.setSpriteFrame(this.sticker.image);
            this.image.setVisible(true);
            this.createFrame(this.sticker.isRare());
            this.text.setVisible(true);
            this.removeRarityIndicator();
        } else {
            this.createFrame();

            if (styles.hideLocked) {
                this.text.setVisible(false);
                this.image.setVisible(false);
            }
        }

        this.text.setAlignment(opened ? styles.label.openedPosition : styles.label.lockedPosition);

        if (this.options.badge && this.sticker.hasAttention()) {
            this.createBadge();
        } else {
            this.removeBadge();
        }
    },

    createLabel: function () {
        const styles = cleverapps.styles.StickerView.label;

        const text = this.text = cleverapps.UI.generateOnlyText(Messages.get(this.sticker.title), cleverapps.styles.FONTS.COLLECTION_WINDOW_TEXT);
        text.setAlignment(styles.lockedPosition);
        text.fitTo(styles.width);
        text.setLocalZOrder(12);

        this.addChild(text);
    },

    createBadge: function () {
        if (this.badge) {
            return;
        }

        const styles = cleverapps.styles.StickerView.badge;

        const badge = this.badge = new cc.Sprite(bundles.sticker.frames.sticker_badge_png);
        badge.setLocalZOrder(11);

        const text = cleverapps.UI.generateOnlyText(Messages.get("Attention.Text"), cleverapps.styles.FONTS.COLLECTION_BADGE_TEXT);

        badge.addChild(text);
        text.setAlignment(styles.text);
        text.fitTo(styles.text.maxWidth);
        text.setRotation(styles.text.rotation);

        this.addChild(badge);
        badge.setAlignment(styles);
    },

    removeBadge: function () {
        if (!this.badge) {
            return;
        }

        this.badge.removeFromParent();
    },

    getDuplicateBadge: function () {
        if (this.duplicateBadge) {
            return this.duplicateBadge;
        }

        const styles = cleverapps.styles.StickerView.badge;

        const badge = this.duplicateBadge = new cc.Sprite(bundles.sticker.frames.sticker_badge_png);
        badge.setLocalZOrder(11);

        const amount = this.sticker.isRare() ? StickersCollection.RARE_POINTS : StickersCollection.REGULAR_POINTS;
        const text = cleverapps.UI.generateOnlyText(`x${amount}`, cleverapps.styles.FONTS.STICKER_POINTS_TEXT);

        badge.addChild(text);
        text.setAlignment(styles.text);
        text.fitTo(styles.text.maxWidth);
        text.setRotation(styles.text.rotation);
        badge.setAlignment(styles);

        return badge;
    },

    removeDuplicateBadge: function () {
        if (!this.duplicateBadge) {
            return;
        }

        this.duplicateBadge.removeFromParent();
    },

    changeStickerToJoker: function (delay, silent) {
        if (!this.jokerIcon) {
            this.setCascadeOpacityEnabled(true);
            const jokerIcon = this.jokerIcon = new cc.Sprite(bundles.stickers_reward_window.frames.joker_icon_png);
            this.addChild(jokerIcon);
            jokerIcon.setAlignment(this.width / 2, this.height / 2);
            jokerIcon.setVisible(false);

            const duplicateFont = this.sticker.isRare()
                ? cleverapps.styles.FONTS.DUPLICATE_TEXT_RARE
                : cleverapps.styles.FONTS.DUPLICATE_TEXT;

            const duplicateLabel = this.duplicateLabel = this.duplicateLabel = cleverapps.UI.generateOnlyText(Messages.get("Duplicate.Text"), duplicateFont);
            jokerIcon.addChild(duplicateLabel);
            duplicateLabel.setAlignment(cleverapps.styles.StickerView.text);

            jokerIcon.addChild(this.getDuplicateBadge());
        }

        const onChanged = () => {
            this.text.removeFromParent();
            this.image.removeFromParent();
            this.frame.removeFromParent();
            this.removeBadge();

            this.parent.setOpacity(255);
            this.jokerIcon.setVisible(true);
        };

        if (silent) {
            onChanged();
            return;
        }

        const effect = new cleverapps.Spine(bundles.stickers_reward_window.jsons.collect_sticker_light_json);
        this.addChild(effect);
        effect.setAlignment(cleverapps.styles.StickerView.effect);

        return new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.CallFunc(() => {
                effect.setAnimation(0, "animation", false);
                effect.setCompleteListenerRemove();
                cleverapps.effects.fire("stickers.window.joker");
            }),
            new cc.Spawn(
                new cc.Sequence(
                    new cc.ScaleTo(0.3, 0.6).easing(cc.easeIn(2)),
                    new cc.ScaleTo(0.3, 1.1).easing(cc.easeOut(2))
                ),
                new cc.Sequence(
                    new cc.DelayTime(0.3),
                    new cc.FadeOut(0.3)
                )
            ),
            new cc.CallFunc(onChanged),
            new cc.ScaleTo(0.2, 1)
        );
    },

    removeRarityIndicator: function () {
        if (this.rarityIndicator) {
            this.rarityIndicator.removeFromParent(true);
        }
    }
});

cleverapps.styles.StickerView = {
    image: {
        x: { align: "center" },
        y: { align: "center", dy: 35 }
    },

    label: {
        openedPosition: {
            x: { align: "center" },
            y: { align: "top", dy: -265 }
        },
        lockedPosition: {
            x: { align: "center" },
            y: { align: "top", dy: -265 }
        },
        width: 170
    },

    badge: {
        x: { align: "right", dx: 30 },
        y: { align: "top", dy: 20 },
        text: {
            x: { align: "center" },
            y: { align: "center" },
            maxWidth: 70,
            rotation: 20
        }
    },

    text: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 98 }
    },

    effect: {
        x: { align: "center" },
        y: { align: "center" }
    },

    tape: false,

    frame: {
        zOrder: 1
    },

    rarityIndicator: {
        zOrder: 2,
        x: { align: "center" },
        y: { align: "top", dy: -20 }
    }
};